<template>
  <div class="delivery_order">
    <!-- main frame -->
    <v-container grid-list-md fluid>
      <!-- part 1 DO detail  -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10" color="blue-grey lighten-5">
            <!-- <v-card-title>
              <v-icon large left>zoom_out_map</v-icon>
              <span class="title font-weight-heavy">Create DO</span>
            </v-card-title>-->

            <v-card-text>
              <v-layout wrap row justify-space-around>
                <!-- DO create date -->
                <v-flex xs3>
                  <v-menu
                    lazy
                    :close-on-content-click="true"
                    v-model="date_box"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Date"
                      v-model="date"
                      persistent-hint
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="date" @input="date_box = false" no-title actions></v-date-picker>
                  </v-menu>
                </v-flex>
                <!-- farmer selection  -->
                <v-flex xs3>
                  <v-autocomplete
                    v-model="farmer"
                    :items="farmerList"
                    item-text="name"
                    item-value="id"
                    label="Farmer"
                    ref="farmer"
                    persistent-hint
                    return-object
                    small-chips
                  ></v-autocomplete>
                </v-flex>

                <!-- button setting -->
                <!-- <v-flex xs1>
              

                  <v-dialog v-model="setting_dialog" max-width="500px">
                    <v-btn color="primary" slot="activator">Setting</v-btn>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Setting</span>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-container grid-list-xs>
                          <v-layout wrap>
                            <v-flex xs12 lg12 sm12 md12>
                              <v-checkbox v-model="setting1" label="Grade"></v-checkbox>

                              <v-text-field
                                v-model="new_grade"
                                append-icon="add"
                                label="New grade"
                                single-line
                                hide-details
                                @click:append="add_grade()"
                              ></v-text-field>

                              <v-data-table
                                :items="gradeList"
                                disable-initial-sort
                                class="elevation-1"
                                hide-headers
                                hide-actions
                                height="100px"
                              >
                                <template slot="items" slot-scope="props">
                                  <tr>
                                    <td class="text-xs-right">{{ props.item.name }}</td>
                                    <td class="text-xs-right">
                                      <v-icon
                                        medium
                                        color="error"
                                        @click="delete_grade(props.item.id)"
                                      >clear</v-icon>
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>

                              <v-checkbox v-model="setting3" label="Location"></v-checkbox>
                              <v-text-field
                                v-model="new_location"
                                append-icon="add"
                                label="New location"
                                single-line
                                hide-details
                                @click:append="add_location()"
                              ></v-text-field>

                              <v-data-table
                                :items="locationList"
                                disable-initial-sort
                                class="elevation-1"
                                hide-headers
                                hide-actions
                                height="100px"
                              >
                                <template slot="items" slot-scope="props">
                                  <tr>
                                    <td class="text-xs-right">{{ props.item.name }}</td>
                                    <td class="text-xs-right">
                                      <v-icon
                                        medium
                                        color="error"
                                        @click="deletelocation(props.item)"
                                      >clear</v-icon>
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                              <v-checkbox v-model="setting2" label="Price"></v-checkbox>

                              <v-text-field
                                v-model="limitDay"
                                type="number"
                                v-on:change="limitDay = Math.max(Math.min(Math.round(limitDay), 10), 1)"
                                label="Previous Day Stock"
                                box
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          flat
                          @click.native="setting_dialog= false"
                        >Close</v-btn>
                        <v-btn
                          color="blue darken-1"
                          flat
                          @click.native="return_basket_from_farmer"
                        >Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>-->
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- part 2 DO item -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <!--  insert item into DO -->
              <v-layout wrap row>
                <!--  Select Product -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="product"
                    :items="productList"
                    item-text="product_code_name"
                    item-value="id"
                    v-on:keyup.enter="checkingProudctType(),VegeNext()"
                    v-on:change="checkingProudctType()"
                    label="Vege"
                    ref="product"
                    chips
                    return-object
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.product_code_name }} &nbsp; &nbsp;
                      <v-avatar size="38">
                        <img :src="(baseUrl+'/product/vege_img/'+item.picture)" />
                      </v-avatar>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!--  Select Grade -->
                <v-flex xs1 v-if="setting_grade == true">
                  <v-autocomplete
                    v-model="grade"
                    :items="gradeList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="GradeNext()"
                    label="Grade"
                    ref="grade"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Select Location -->
                <v-flex xs1 v-if="setting_location == true">
                  <v-autocomplete
                    v-model="location"
                    :items="locationList"
                    item-text="name"
                    v-on:keyup.enter="LocationNext()"
                    item-value="name"
                    label="Location"
                    ref="location"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Type Weight -->
                <v-flex xs2>
                  <v-text-field
                    v-if="product_type_need_weight==true"
                    v-model="weight"
                    v-on:keyup.enter="WeightNext()"
                    v-on:change="weight = Math.max(Math.min(weight, 9999999), 0.1)"
                    type="number"
                    ref="weight"
                    label="weight(kg)"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Quantity -->
                <v-flex xs2>
                  <v-text-field
                    v-model="quantity"
                    v-on:keyup.enter="QuantityNext()"
                    v-on:change="quantity = Math.max(Math.min(Math.round(quantity), 9999999), 1)"
                    ref="qty"
                    type="number"
                    label="Qty"
                    box
                  ></v-text-field>
                </v-flex>

                <!-- Type Price -->
                <v-flex xs1 v-if="setting_price == true">
                  <v-text-field
                    v-model="price"
                    v-on:keyup.enter="PriceNext();"
                    v-on:change="price = Math.max(Math.min(price, 9999999), 0)"
                    ref="price"
                    type="number"
                    label="Price"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-btn color="primary" @click="additemToPO()">
                    <v-icon>subdirectory_arrow_left</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>

              <!-- do item local table -->
              <v-layout>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="local_po_stock"
                    disable-initial-sort
                    class="elevation-1"
                    :rows-per-page-items="[100, 150, 200, 250]"
                    height="60px"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-avatar size="38">
                            <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                          </v-avatar>
                        </td>
                        <td class="text-xs-right">{{ props.item.product_name }}</td>
                        <td class="text-xs-right">{{ props.item.grade }}</td>
                        <td class="text-xs-right">{{ props.item.location }}</td>
                        <td class="text-xs-right">{{ props.item.weight }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>
                        <td class="text-xs-right">{{ props.item.price }}</td>

                        <td class="justify-end layout px-5">
                          <v-icon
                            medium
                            color="error"
                            @click="deletePOitem(props.item)"
                          >delete_forever</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-row>
                <v-btn
                  color="primary"
                  :loading="saving"
                  :disabled="saving"
                  @click.native="save_invoice"
                >Save</v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Loading Dialog when vege adding (Overlay)  -->
    <v-dialog v-model="vege_adding_loading_dialog" overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Adding Vege: {{vege_adding_loading_value}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import moment from "moment";
//import VWidget from "@/components/user_widget/vwidget";
//import delivery_order_list from "@/components/large_component/delivery_order_list";

export default {
  components: {
    //VWidget,
  },
  data() {
    return {
      //fixed
      baseUrl: baseUrl,

      //array
      farmerList: [],
      driverList: [],
      productList: [],
      farmerList_WithSelectedProduct: [],
      gradeList: [],
      locationList: [],
      local_po_stock: [],
      headers: [
        { text: "Image", value: "product_image" },
        { text: "Veg", align: "right", value: "product_name" },
        { text: "Grade", align: "right", value: "grade" },
        { text: "Location", align: "right", value: "location" },
        { text: "Weight/Box", align: "right", value: "weight" },
        { text: "Qty", align: "right", value: "quantity" },
        { text: "RM", align: "right", value: "price" },

        { text: "Actions", align: "right", value: "action", sortable: false }
      ],

      //main value
      date: moment().format("YYYY-MM-DD"),
      farmer: "",
      driver: "",
      product: "",
      weight: "",
      quantity: "",
      price: "",
      grade: "",
      location: "",

      new_grade: "",
      new_location: "",

      //logic control
      product_type_need_weight: true,
      setting_grade: true,
      setting_location: true,
      setting_price: true,
      limitDay: "",
      saving: false,

      //others
      response_detail: "",
      vege_adding_loading_value: "",

      // dialog snackbar date_box
      setting_dialog: false,
      date_box: false,
      vege_adding_loading_dialog: false,
      snackbar_response: false,
      snackbar_no_connection: false
    };
  },
  created() {
    this.getFarmer();

    this.getProduct();
    this.getGrade();
    this.getLocation();
  },
  mounted() {
    this.intervalFetch();
  },
  computed: {},

  methods: {
    getFarmer() {
      const params = new URLSearchParams();
      params.append("get_farmer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_farmer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.farmerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Farmer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    save_invoice() {
      //checking whether data filled
      this.saving = true;
      if (this.date && this.farmer.id && this.local_po_stock.length > 0) {
        const params = new URLSearchParams();
        params.append("create_direct_invoice", "create_direct_invoice");
        params.append("date", this.date);
        params.append("farmer_id", this.farmer.id);
        params.append("po_item_array", JSON.stringify(this.local_po_stock));

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
          data: params
        })
          .then(response => {
            if (response.data.error == false) {
              //set response to selected data
              this.clearallfieldnew();
              this.snackbar_response = true;
              this.response_detail = "New Invoice created";
              this.saving = false;
            this.$emit("update", "someValue");

            } else if (response.data.error == true) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
              this.saving = false;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_connection = true;
            this.saving = false;
          });
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail & vege";
        this.saving = false;
      }
    },
    getProduct() {
      const params = new URLSearchParams();
      params.append("getAllProduct", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.productList = response.data.data;
            this.clearallfield();
          } else if (response.data.error == true) {
            console.log("Product List Problem" + response.data.message);
            this.clearallfield();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },

    additemToPO() {
      //checking whether data filled
      if (this.product.id && this.weight && this.quantity) {
        if (this.grade == "") {
          this.grade = "unknown";
        }
        if (this.location == "") {
          this.location = "unknown";
        }
        if (this.price == "") {
          this.price = "0";
        }
        for (var i = 0; i < this.local_po_stock.length; i++) {
          /*
          checking input
          */

          if (
            this.local_po_stock[i].weight == this.weight &&
            this.local_po_stock[i].grade == this.grade &&
            this.local_po_stock[i].location == this.location &&
            this.local_po_stock[i].product_id == this.product.id
          ) {
            this.local_po_stock[i].quantity += this.quantity;
            this.product = "";
            this.weight = "";
            this.quantity = "";
            this.price = "";
            this.grade = "";
            this.location = "";
            this.$refs.product.focus();

            return;
          }
        }

        this.local_po_stock.push({
          product_image: this.product.picture,
          product_name: this.product.name,
          product_id: this.product.id,
          grade: this.grade,
          location: this.location,
          weight: this.weight,
          quantity: this.quantity,
          price: parseFloat(this.price).toFixed(2),

          type: this.product.type
        });
        this.product = "";

        this.weight = "";
        this.quantity = "";
        this.price = "";
        this.grade = "";
        this.location = "";

        this.nextToVege();
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail";
      }
    },
    deletePOitem(item) {
      const index = this.local_po_stock.indexOf(item);
      this.local_po_stock.splice(index, 1);
    },
    checkingProudctType() {
      if (this.product.type == "box" || this.product.type == "bag" || this.product.type == "pcs"|| this.product.type == "pkt"){
        this.product_type_need_weight = false;
        this.weight = "1";
      } else {
        this.product_type_need_weight = true;
        this.weight = "";
      }
    },
    VegeNext() {
      if (this.setting_grade == true) {
        this.$refs.grade.focus();
        this.$refs.grade.activateMenu();
      } else if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      }else if(this.product.type == "box" || this.product.type == "bag" || this.product.type == "pcs"|| this.product.type == "pkt"){
        this.$refs.qty.focus();
      } else {
        this.$refs.weight.focus();
      }
    },
    GradeNext() {
      if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      } else if(this.product.type == "box" || this.product.type == "bag" || this.product.type == "pcs"|| this.product.type == "pkt"){
        this.$refs.qty.focus();
      }else {
        this.$refs.weight.focus();
      }
    },
    LocationNext() {
       if(this.product.type == "box" || this.product.type == "bag" || this.product.type == "pcs"|| this.product.type == "pkt"){
        this.$refs.qty.focus();
      }{
      this.$refs.weight.focus();}
    },
    WeightNext() {
      this.$refs.qty.focus();
    },
    QuantityNext() {
      if (this.setting_price == true) {
        this.$refs.price.focus();
      } else {
        this.additemToPO();
      }
    },
    PriceNext() {
      this.additemToPO();
    },
    nextToVege() {
      this.$refs.product.focus();
    },
    clearallfield() {
      this.farmer = "";
      this.driver = "";

      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
    },
    clearallfieldnew() {
      this.farmer = "";
      this.driver = "";
      this.local_po_stock = [];
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
    },
    intervalFetch: function() {
      setInterval(() => {
        this.limitDay = localStorage.stocked_day_limit;
        this.setting_grade = localStorage.setting_grade;
        this.setting_location = localStorage.setting_location;

        if (this.setting_grade == "true") {
          this.setting_grade = true;
        } else {
          this.setting_grade = false;
        }
        if (this.setting_location == "true") {
          this.setting_location = true;
        } else {
          this.setting_location = false;
        }
      }, 500);
    }
  }
};
</script>

